export const PROJECT_STATUS_NAME_DRAFT = 'draft';
export const PROJECT_STATUS_NAME_AGREEMENT = 'agreement';
export const PROJECT_STATUS_NAME_IN_WORK = 'in_work';
export const PROJECT_STATUS_NAME_ACCEPTANCE = 'acceptance';
export const PROJECT_STATUS_NAME_CLOSED = 'closed';
export const PROJECT_STATUS_NAME_REJECTED = 'rejected';
